"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var react_i18next_1 = require("react-i18next");
var Modal_1 = __importDefault(require("../../../../common/Modal/Modal"));
var Button_1 = __importDefault(require("../../../../common/Button/Button"));
var icons_1 = __importDefault(require("../../../../theme/icons"));
var MonitoringCategory = function (_a) {
    var any = _a.list;
    var organization = (0, org_hook_1.useOrg)().organization, _b = (0, react_i18next_1.useTranslation)(), i18n = _b.i18n, t = _b.t, _c = (0, react_1.useState)([
        {
            id: null,
            name: {},
            sorting: null,
            organization_id: null,
        },
    ]), fields = _c[0], setFields = _c[1], _d = (0, react_1.useState)([]), error = _d[0], setError = _d[1];
    var triggerButton = function () {
        react_1.default.createElement("div", { className: "absoulte-buttom", style: { top: "8.3rem" } },
            react_1.default.createElement(Button_1.default, { className: "form-buttom", icon: react_1.default.createElement(icons_1.default, { name: "plus", className: "icon", height: 30, width: 30 }), text: t("add_category") }));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Modal_1.default, { title: t("add_category"), triggerButton: triggerButton() })));
};
exports.default = MonitoringCategory;
